import type { FaireProductEntity } from "../../entity_types/product";

export const p_1abw42s: FaireProductEntity = {
  token: "p_1abw42s",
  type: "product",
  name: "Ssamjang Korean Barbeque Sauce",
  brandName: "Potluck",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c171978c55a1b25e5a677018a94d8113b4387f31e83c6ef062b5a136c29f7986.webp",
  priceDollars: 12,
  description:
    "A savory Korean condiment that blends fermented soybean paste with gochujang, sesame oil, garlic, and other aromatics.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["korean", "sauce", "condiment", "premium", "artisanal"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/6edcc1e721d6c6e418cb5378f3f92caca5f10171ea43c6c3da92e2bc6f9da5b1.webp",
  weight: 1.2,
  dimensions: {
    width: 3,
    height: 5,
    depth: 3,
  },
  inStock: true,
};
